export const extractLocationInfoFromContext = data => {
  const placeData = data?.context || [];

  const extractMultilingualFields = (feature, baseField) => {
    const values = {};
    for (const key in feature) {
      if (key.startsWith(baseField)) {
        const lang = key === baseField ? 'default' : key.replace(`${baseField}_`, '');
        values[lang] = feature[key];
      }
    }
    return values;
  };

  const locationInfo = {
    placeNames: extractMultilingualFields(data, 'place_name'),
    cityNames: data?.text
      ? extractMultilingualFields(data, 'text')
      : data?.matching_text && extractMultilingualFields(data, 'matching_text'),
  };

  placeData.forEach(feature => {
    if (feature?.id?.includes?.('country')) {
      locationInfo.countryCode = feature?.short_code?.toUpperCase?.();
      locationInfo.countryNames = extractMultilingualFields(feature, 'text');
    } else if (feature?.id?.includes?.('region')) {
      locationInfo.regionCode = feature?.short_code;
      locationInfo.regionNames = extractMultilingualFields(feature, 'text');
    } else if (feature?.id?.includes?.('place')) {
      locationInfo.cityNames = extractMultilingualFields(feature, 'text');
    }
  });

  return locationInfo;
};

export const getLocalizedField = (locationInfo, field, language) => {
  const fieldObj = locationInfo?.[field];
  if (!fieldObj || typeof fieldObj !== 'object') return null;

  return fieldObj[language] ?? fieldObj.default ?? null;
};

/**
 * Formats city and country in either language-based or code-based format.
 *
 * @param {Object} locationInfo - Object from extractLocationInfoFromContext.
 * @param {string} language - Language code for localized name (e.g., 'en', 'nl').
 * @param {boolean} useCountryCode - If true, returns `${city}, ${countryCode}` instead.
 * @returns {string|null} - The formatted string or null if city/country is missing.
 */
export const formatLocation = (locationInfo, language = 'nl', useCountryCode = false) => {
  if (!locationInfo) return null;

  const city = getLocalizedField(locationInfo, 'cityNames', language) || locationInfo.city;
  const country = useCountryCode
    ? locationInfo.countryCode
    : getLocalizedField(locationInfo, 'countryNames', language);
  const placeName = getLocalizedField(locationInfo, 'placeNames', language);
  if (!city || !country) return placeName;

  return `${city}, ${country}`;
};

export const sanitizeAddress = location => {
  return location?.selectedPlace?.address
    ? { address: location?.selectedPlace.address }
    : location?.selectedPlace
    ? { address: location?.selectedPlace }
    : location?.address
    ? { address: location?.address }
    : null;
};
